"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ArrowComponent = _interopRequireDefault(require("./ArrowComponent"));

var _ArrowSvg = _interopRequireDefault(require("./ArrowSvg2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var index = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(index, _React$PureComponent);

  function index() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = index.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement(_ArrowComponent["default"], _extends({
      defaultPosition: "down",
      Svg: _ArrowSvg["default"]
    }, this.props));
  };

  return index;
}(_react["default"].PureComponent);

var _default = index;
exports["default"] = _default;
module.exports = exports.default;